// extracted by mini-css-extract-plugin
module.exports =  {"container":"_9cadcb71c3--container--t841O","title":"_9cadcb71c3--title--zgXrS","value":"_9cadcb71c3--value--MohP9"};